const subscription = {
    limit_exceeded: '定めた定期プランの上限に達しました。',
    get_plan_failed: 'テナントのサブスクリプションプランを取得できませんでした。',
    tenant_suspended: 'テナントが停止されています。管理者に連絡してください。',
};
export default Object.freeze(subscription);
